<app-table
  [specifications]="compareSpecs"
  [rowHasSpecDifferences]="rowHasSpecDifferences"
  [hideSpecDifferenceRows]="filtered"
></app-table>
